import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import { ErrorState, LoadingState, SharedUiThemeProvider } from '@harver/shared-ui';

import { defaultTheme } from '../branding/theme';
import { GlobalStyle } from '../components/GlobalStyle';
import { Layout } from '../components/Layout';
import OpenInviteDetails from './openInvite/OpenInviteDetails';
import { getBrand, OrganizationConfig } from '../branding';
import ContentContextProvider from '../branding/content.context';

enum Paths {
    openInvite = '/interview/invite/:openInviteId',
}

interface BrandedConfigState {
    isLoading: boolean;
    error?: any;
    config?: OrganizationConfig;
}

function App(): JSX.Element {
    const url = window.location.href;
    const linkId = url.split('/').pop() as string;
    const [brandedConfig, setBrandedConfig] = useState<BrandedConfigState>({
        isLoading: true,
    });

    useEffect(() => {
        const getBrandConfig = async () => {
            try {
                const config = await getBrand(linkId);
                const faviconEl = document.getElementById('favicon') as HTMLLinkElement;
                if (faviconEl) faviconEl.href = config.favicon;

                if (config.content.locale) {
                    // Add the locale to html lang attribute
                    document.documentElement.lang = config.content.locale.replace('_', '-');
                }

                setBrandedConfig({ isLoading: false, config });
            } catch (error) {
                setBrandedConfig({ isLoading: false, error });
            }
        };
        getBrandConfig();
    }, [linkId]);

    if (brandedConfig.isLoading) {
        return (
            <SharedUiThemeProvider theme={defaultTheme}>
                <GlobalStyle />
                <LoadingState testId="app.loading" />
            </SharedUiThemeProvider>
        );
    }

    if (brandedConfig.error || !brandedConfig.config) {
        document.title = 'Something went wrong';
        return (
            <SharedUiThemeProvider theme={defaultTheme}>
                <GlobalStyle />
                <ErrorState testId="branding.errorScreen" onReloadClick={() => window.location.reload()} />
            </SharedUiThemeProvider>
        );
    }

    return (
        <SharedUiThemeProvider theme={brandedConfig.config.theme}>
            <GlobalStyle />
            <Layout>
                <Router>
                    <ContentContextProvider value={brandedConfig.config.content}>
                        <Route path={Paths.openInvite} component={OpenInviteDetails} />
                    </ContentContextProvider>
                </Router>
            </Layout>
        </SharedUiThemeProvider>
    );
}

export default App;
